<template>
    <!-- 导航 -->
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'" :close="true">
        <template v-slot:title>
            <span class="nav-title">新华数藏</span>
        </template>
    </NavBar>
    <div class="content-box">
        <!-- 轮播 -->
        <div class="imgswiper" v-if="banners.length">
            <my-swiper class="img-item" :data="banners" srcProp="image" />
        </div>
        <div class="notice" v-if="notices.length">
            <img src="@/assets/images/horn-index.png" class="horn" v-if="!$newYearStyle">
            <img src="@/assets/images1/newYear/horn-index.png" class="horn" v-else>
            <div class="swiper">{{ notices[noticeIndex].title }}</div>
            <router-link to="/notice">
                <img src="@/assets/images/notice-index-list.png" class="list" v-if="!$newYearStyle">
                <img src="@/assets/images1/newYear/notice-index-list.png" class="list" v-else>
            </router-link>
        </div>
        <!-- 导航盒子 -->
        <div class="centerBar">
            <div class="centerBar-box">
                <router-link to="/calendar">
                    <div class="centerBar-box-flexbox">
                        <van-image
                            class="img-item"
                            :src="require('@/assets/images/calendar.png')"
                            v-if="!$newYearStyle"
                        ></van-image>
                        <van-image
                            class="img-item"
                            :src="require('@/assets/images1/newYear/calendar.png')"
                            v-else
                        ></van-image>
                        <span>发售日历</span>
                    </div>
                </router-link>
                <span class="line"></span>
                <router-link to="/personal">
                    <div class="centerBar-box-flexbox">
                        <van-image
                            class="img-item"
                            :src="require('@/assets/images/warehouse.png')"
                            v-if="!$newYearStyle"
                        ></van-image>
                        <van-image
                            class="img-item"
                            :src="require('@/assets/images1/newYear/warehouse.png')"
                            v-else
                        ></van-image>
                        <span>我的藏库</span>
                    </div>
                </router-link>
            </div>
        </div>

        <!-- 切换/搜索 -->
        <div class="centerSeart">
            <div class="colorBoxLeft"></div>
            <div class="sear-box" :class="{hide: ! searchShow}">
                <van-search shape="round" placeholder="请输入搜索关键词" @search="search" v-model="keyword">
                    <template #left-icon>
                        <img
                            src="@/assets/images/search.png"
                            class="sear-icon"
                            alt=""
                        />
                        <!-- <van-icon name="search" color="#fff" class="sear-icon" /> -->
                    </template>
                </van-search>
                <van-image
                    class="img-right"
                    :src="require('@/assets/images/more.png')"
                    @click="toggleSearch"
                ></van-image>
            </div>
            <div class="tab-box" :class="{hide: searchShow}">
                <van-image
                    class="img-left"
                    :src="require('@/assets/images/magnifying-glass.png')"
                    @click="toggleSearch"
                ></van-image>
                <div class="list">
                    <span class="item" :class="{active: state == ''}" @click="selectState('')">全部</span>
                    <span class="item" :class="{active: state == states.waiting}" @click="selectState(states.waiting)">预发售</span>
                    <span class="item" :class="{active: state == states.normal}" @click="selectState(states.normal)">发售中</span>
                    <span class="item" :class="{active: state == states.sellout}" @click="selectState(states.sellout)">已售罄</span>
                </div>
            </div>
        </div>

        <!-- 产品列表 -->
        <div class="commodity-box" v-if="products.length">
            <div v-for="product in products" :key="product.id" @click="jumpLink(product.detail_url ? product.detail_url : ('/product/' + product.id))">
                <div class="commodity-list">
                    <div class="box-top">
                        <div class="top-top flex-y-center">
                            <span class="sell-out" v-if="product.state == states.sellout">已售罄</span>
                            <section v-else-if="product.state == states.waiting">
                                <span class="on-sale">发售时间</span>
                                <span class="time">{{ dateFormat('YYYY-mm-dd HH:ii:ss', product.release_time) }}</span>
                            </section>
                            <span class="sell-out" v-else-if="product.state == states.offline">已结束</span>
                            <span class="on-sale" v-else>发售中</span>
                            <section class="flex-y-center debris-box" v-if="product.type == types.fragment">
                                <img src="@/assets/images/debris.png" alt="" />
                                <span class="debris">藏品碎片</span>
                            </section>
                        </div>
                        <van-image fit="cover" class="img" alt="" :src="product.cover"/>
                        <div class="music" v-if="product.is_music">
                            <img src="@/assets/images/music.png">
                            <span>音乐</span>
                        </div>
                    </div>
                    <div class="box-bottom">
                        <p class="title">{{ product.name }}</p>
                        <div class="tag-box">
                            <span class="title-left" v-if="product.tags.length">{{ product.tags[0].name }}</span>
                            <span class="tag-r1">{{ product.stock_show ? '剩余' : '限量' }}</span>
                            <span class="tag-r2">{{ product.stock_show ? product.stock : product.total }}个</span>
                        </div>
                        <div class="creater-box" v-if="product.organization_show">
                            <van-image
                                class="img-head"
                                round
                                :src="product.organization.logo"
                            ></van-image>
                            <p class="issuer-title">创作者：</p>
                            <p class="issuer-describe">{{ product.organization.name }}</p>

                            <!-- <section class="issuer">
                            </section> -->
                        </div>
                        <div class="foot-btn">
                            <span class="fee" :class="{free: product.price == 0}">{{ product.price > 0 ? '¥ ' + product.price : '免费领取' }}</span>
                            <template v-if="product.state == states.waiting">
                                <span class="solidBtn" v-if="! product.raffle" @click.stop="toggleSubscribe(product.id)">
                                    {{ subscribes.indexOf(product.id) > -1 ? '预约成功' : '立即预约' }}
                                </span>
                                <router-link :to="'/product/' + product.id" class="solidBtn" v-else>
                                    {{ product.raffle.diff ? `抽签倒计时 ${prefixZero(product.raffle.diff.hour)}:${prefixZero(product.raffle.diff.minute)}:${prefixZero(product.raffle.diff.second)}` : (subscribes.indexOf(product.id) > -1 ? '预约成功' : '立即预约') }}
                                </router-link>
                            </template>
                            <span class="subBtn" v-else-if="product.state == states.sellout">已售罄</span>
                            <span class="subBtn" v-else-if="product.state == states.offline">已结束</span>
                            <span class="solidBtn" v-else>马上抢</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot-text" v-if="! more">这是底线</div>
        </div>

        <div class="commodity-box" v-else></div>

        <van-overlay :show="showWelfareAlert" class="success-overlay">
            <div class="unpack">
                <img src="@/assets/images/blindbox.png" class="blindbox">
                <p class="title">获得福利</p>
                <a href="javascript:;" class="button" @click="showWelfareAlert = false;showWelfareInfo = true;">打开福利</a>
                <img src="@/assets/images/close.png" class="close" @click="showWelfareAlert = false">
            </div>
        </van-overlay>
        <van-overlay :show="showWelfareInfo" class="success-overlay">
            <div class="welfare">
                <img src="@/assets/images/close.png" class="close" @click="showWelfareInfo = false">
                <img :src="welfare.cover" class="cover">
                <img src="@/assets/images/welfare_line.png" class="line">
                <p class="title">{{welfare.name}}</p>
                <p class="title">领取说明</p>
                <pre class="description">{{welfare.description}}</pre>
                <router-link :to="'/welfare/' + welfare.id" class="button">填写联系方式</router-link>
            </div>
        </van-overlay>
        <img src="@/assets/images/gotop.png" class="gotop" @click="goTop" v-if="showGoTopBtn && !$newYearStyle">
        <img src="@/assets/images1/newYear/gotop.png" class="gotop" @click="goTop" v-if="showGoTopBtn && $newYearStyle">
        <!-- 去登陆，不需要可以删除 -->
        <div class="go-login" v-if="showLogin && $store.state.authorizationTime < new Date().getTime()">
            <div>登录后可以收藏/购买数字藏品</div>
            <a href="javascript:;" class="btn-login" @click="login('/')">去登录</a>
            <div class="close-login" @click="showLogin = false"></div>
        </div>
        <Draw></Draw>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>